export default __webpack_public_path__ + "static/media/TableFilterIcon.b662bed6.svg";